var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0457 0.337646C13.958 0.337646 0.854248 13.3765 0.854248 29.5291C0.854248 45.6817 13.958 58.7205 30.0457 58.7205C46.1334 58.7205 59.2371 45.6817 59.2371 29.5291C59.2371 13.3765 46.1334 0.337646 30.0457 0.337646ZM22.1316 44.514V14.5441L45.8739 29.5291L22.1316 44.514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d29072979eeac4544144cd8674e96ffb.svg";
export { ForwardRef as ReactComponent };